import { useState } from 'react';
import { toast } from 'sonner';
import { Lightning, X } from '@phosphor-icons/react';
import api from '../lib/api';

// Confirmation card for Crunchy's bulk_edit_contacts (status/tags only).
export default function BulkEditConfirmDialog({ open, preview, onClose, onApplied }) {
  const [applying, setApplying] = useState(false);
  if (!open || !preview) return null;

  const apply = async () => {
    setApplying(true);
    try {
      const { data } = await api.post('/ai/contacts/bulk-edit', {
        action: preview.action,
        value: preview.value,
        target: preview.target,
      });
      toast.success(`✓ Updated ${data.modified_count} contact${data.modified_count !== 1 ? 's' : ''}`);
      onApplied?.(data);
      onClose();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Bulk edit failed');
    } finally {
      setApplying(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[9998] bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="bulk-edit-overlay">
      <div className="bg-white border border-[#B0B0B0] shadow-2xl w-full max-w-[420px]" onClick={(e) => e.stopPropagation()}>
        <div className="px-3 py-2 bg-[#0B5394] text-white text-[12px] font-bold flex items-center justify-between">
          <span className="flex items-center gap-1.5"><Lightning size={14} weight="fill" /> Bulk Edit — Confirm</span>
          <button onClick={onClose} className="p-0.5 hover:bg-white/20 rounded" data-testid="bulk-edit-close" aria-label="Close">
            <X size={13} weight="bold" />
          </button>
        </div>
        <div className="p-4">
          <p className="text-[13px] text-[#333]" data-testid="bulk-edit-summary">
            This will <strong>{preview.action_desc}</strong> on{' '}
            <strong>{preview.count} {preview.target_desc}</strong>.
          </p>
          {(preview.sample || []).length > 0 && (
            <p className="text-[11px] text-[#666] mt-2">
              Including: {preview.sample.join(', ')}{preview.count > preview.sample.length ? '…' : ''}
            </p>
          )}
          <p className="text-[10px] text-[#999] mt-2">Only status and tags can be bulk-edited — notes, emails and phones are protected by design.</p>
        </div>
        <div className="px-4 py-2.5 border-t border-[#EEE] flex justify-end gap-2">
          <button onClick={onClose} className="px-3 py-1.5 text-[11px] border border-[#999] bg-white hover:bg-[#F5F5F5]" data-testid="bulk-edit-cancel">Cancel</button>
          <button onClick={apply} disabled={applying} className="px-3 py-1.5 text-[11px] font-bold bg-[#0B5394] hover:bg-[#094180] text-white disabled:opacity-60" data-testid="bulk-edit-apply">
            {applying ? 'Applying…' : `Apply to ${preview.count} contacts`}
          </button>
        </div>
      </div>
    </div>
  );
}
